import BaseModel from "../default/base-model";
import {Category} from "./category";
import {Client} from "./client";
import {Project} from "./project";

export class RelatedCost extends BaseModel {
  id: number;
  client: string;
  project: string;
	total_nre: number;
  total_amortized: number;
  items: RelatedCostItem[];

  constructor() {
    super();
    this.id = 0;
    this.client = "";
    this.project = "";
    this.total_nre = 0;
    this.total_amortized = 0;
    this.items = [];
  }
}

export class RelatedCostItem {
  id: number;
  date: string;
  cy: number;
  invoice: string;
  type: RelatedCostType;
  category_name: string;
	material: string;
  description: string;
  qty: number;
  unit_net: number;
  taxes: number;
  total: number;

  constructor() {
    this.id = 0;
    this.date = "";
    this.cy = 0;
    this.invoice = "";
    this.type = RelatedCostType.NRE_COST;
    this.category_name = "";
    this.description = "";
    this.material = "";
    this.qty = 0;
    this.unit_net = 0;
    this.taxes = 0;
    this.total = 0;
  }
}

export enum RelatedCostType {
  NRE_COST = 1,
  AMORTIZATION = 2
}

export class RelatedCostForm extends BaseModel {
  type: RelatedCostType;
  client: Client;
  date: Date | null;
  project: Project;
  cy?: number;
  invoice: string;
  category: Category;
  description: string;
  same_values: boolean;
  total: number;
  items: RelatedCostFormItem[];
  formatted_total?: string;
  errors?: any[];

  constructor() {
    super();
    this.type = RelatedCostType.NRE_COST;
    this.client = new Client();
    this.date = null;
    this.project = new Project();
    this.cy = 0;
    this.invoice = "";
    this.category = new Category();
    this.description = "";
    this.same_values = true;
    this.total = 0;
    this.items = [];
    this.errors = [];
  }
}

export class RelatedCostFormItem {
  project: Project;
  value: number;
  formatted_value?: string;
  
  constructor() {
    this.project = new Project();
    this.value = 0;
  }
}

